import { formatMacAddress } from 'src/utils/useful_functions';

const MacRenderer = (props) => {
  const { context } = props;
  return formatMacAddress(props.value, context.prefs.macAddressFormat);
};

export default MacRenderer;
